import React from "react";
import { Layout, Menu } from "antd";
import {
  ContainerOutlined,
  DollarOutlined,
  CarOutlined,
} from "@ant-design/icons";
import { useMainLayout } from "./MainLayoutProvider";
import { Link } from "react-router-dom";
import { UserMenu } from "./UserMenu";
import AppBreadcrumb from "src/components/Breadcrumb";

const { Header, Sider, Content } = Layout;

const MainLayout = ({ children }) => {
  const { collapsed, toggleSidebar } = useMainLayout();

  const sideBarItems = [
    {
      key: "contracts",
      icon: <ContainerOutlined />,
      label: <Link to="/contracts">Contracts</Link>,
    },
    {
      key: "bikes",
      icon: <CarOutlined />,
      label: <Link to="/bikes">Bikes</Link>,
    },
    {
      key: "expenses",
      icon: <DollarOutlined />,
      label: <Link to="/expenses">General Expenses</Link>,
    }
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={toggleSidebar}>
        <div
          className="logo"
          style={{ padding: "16px", alignItems: "center", display: "flex" }}
        >
          <img src="/jblogo.png" alt="JustBike Logo" />
        </div>
        <Menu mode="inline" theme="dark" items={sideBarItems} />
      </Sider>

      <Layout>
        <Header
          style={{
            background: '#fff',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ marginRight: '16px' }}>
            <UserMenu />
          </div>
        </Header>
        <Content style={{ margin: "16px" }}>
          <AppBreadcrumb />
          <div style={{ padding: 24, background: "#fff", minHeight: 360 }}>
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
